/** Saved alongside the ledger; amounts come directly from the projection engine. */
export interface FireCashFlowDetail {
  asOf: string | null;
  yearFraction: number;
  incomeStreams: { name: string; type: string; annualAmount: number }[];
  expenseCategories: { name: string; group: string; annualAmount: number }[];
  lifeEvents: {
    description: string;
    type: "expense" | "inheritance" | "asset_sale";
    amount: number;
  }[];
}

/** Life-event spending is separate from recurring expenses and counted once. */
export function summarizeFireCashFlow(detail: FireCashFlowDetail, taxPaid: number) {
  const income = detail.incomeStreams.reduce((sum, item) => sum + item.annualAmount, 0);
  const expenses = detail.expenseCategories.reduce((sum, item) => sum + item.annualAmount, 0);
  const lifeEvents = detail.lifeEvents.reduce(
    (sum, item) => sum + (item.type === "expense" ? -item.amount : item.amount), 0,
  );
  return { income, expenses, lifeEvents, net: income - expenses - taxPaid + lifeEvents };
}
